import './css/styles.scss';

function kontaktFormInit() {}

kontaktFormInit();
